import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import useAxios from 'axios-hooks';
import Question from './Question';
import useNavigation from '../../../hooks/useNavigation';
import viewStates from '../../../helpers/viewStates';

const StartView = () => {
  const { t } = useTranslation();
  const { view } = useNavigation();

  // get all top level questions from backend
  const [{ data }] = useAxios('/intent');

  useEffect(() => {
    if (data && data.sessionId) {
      localStorage.setItem('session_id', data.sessionId);
    }
  }, [data]);

  return (
    <div id="questions" className={classNames({
      visible: view === viewStates.START,
    })}>
      {/*<p className="questions-header">{t('questions.header')}</p>*/}

      {data && data.intent.answers.map((answer) => <Question key={answer.id} answer={answer} />)}
    </div>
  );
};

export default StartView;
